function max(...args) {
  return Math.max(...args);
}

export default max;
